export interface OfferStatusMapItem {
  title: string;
  renderTitle: (firstName: string, lastName: string) => React.ReactNode;
  infoAlertText: string;
}

export enum ProjectsTabValue {
  MY_PROJECTS = 'MY_PROJECTS',
  HOT_PROJECTS = 'HOT_PROJECTS',
  RECENTLY_CLOSED = 'RECENTLY_CLOSED',
}

export enum MyProjectsCategory {
  CURRENT_OFFERS = 'CURRENT_OFFERS',
  ACCEPTED = 'ACCEPTED',
  CANCELED = 'CANCELED',
}

export enum ProjectsListQueryTab {
  MY_PROJECTS_CURRENT_OFFERS = 'my-projects-current-offers',
  MY_PROJECTS_ACCEPTED = 'my-projects-accepted',
  MY_PROJECTS_CANCELED = 'my-projects-canceled',
  HOT_PROJECTS = 'hot-projects',
  RECENTLY_CLOSED = 'recently-closed',
}
